import { BadgeCheck, User } from 'lucide-react';
import { StarRating } from './StarRating';

export const ReviewCard = ({ review }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div 
      className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow"
      data-testid={`review-card-${review.id}`}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[charcoal] rounded-full flex items-center justify-center">
            <User className="w-5 h-5 text-[gold]" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="font-semibold text-[charcoal]">{review.user_name}</span>
              {review.is_verified && (
                <span 
                  className="inline-flex items-center gap-1 bg-green-50 text-green-700 text-xs font-medium px-2 py-0.5 rounded-full"
                  data-testid="verified-badge"
                >
                  <BadgeCheck className="w-3 h-3" />
                  Verified Buyer
                </span>
              )}
            </div>
            <span className="text-xs text-[charcoal-light]">{formatDate(review.created_at)}</span>
          </div>
        </div>
      </div>

      {/* Rating */}
      <div className="mb-3">
        <StarRating rating={review.rating} size="sm" />
      </div>

      {/* Title */}
      {review.title && (
        <h4 className="font-semibold text-[charcoal] mb-2">{review.title}</h4>
      )}

      {/* Comment */}
      <p className="text-[charcoal-light] text-sm leading-relaxed">{review.comment}</p>

      {/* Images */}
      {review.images && review.images.length > 0 && (
        <div className="flex gap-2 mt-3 overflow-x-auto pb-2">
          {review.images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Review image ${idx + 1}`}
              className="w-20 h-20 object-cover rounded-lg border border-gray-200 flex-shrink-0"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewCard;
